require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/es7.symbol.async-iterator.js
// module id = 181
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 15 16